import { GetPlayerProfileResponse } from 'services/players';
import styles from './honours.module.scss';
import { Award } from '../award/award';
import { useAppTranslation } from 'hooks/use-translates';

type HonoursProps = {
    awards: GetPlayerProfileResponse['awards'];
    name: string;
};

export const Honours = ({ awards, name }: HonoursProps) => {
    const { t } = useAppTranslation();
    return (
        <div className={styles['honours']}>
            <div className={styles['honours__header']}>
                <span className={`${styles['honours__name']} body-small`}>{name}'s</span>
                <h2 className="display-large bold">
                    {t('players_profile.honours_section_title', undefined, 'Honours')}
                </h2>
            </div>
            <ul className={styles['honours__list']}>
                {awards.map((award, index) => (
                    <li key={index} className={styles['honours__item']}>
                        <Award {...award} />
                    </li>
                ))}
            </ul>
        </div>
    );
};
